import { graphClient } from '../graph-client'
import type { LiveCheckinMonth } from '../../types/check-in'
import type { Response } from '../../types/response'
import {
  GET_LIVE_CHECKIN_MONTH_FIRST,
  GET_OR_CREATE_LIVE_CHECKIN_MONTH_CURRENT,
} from './gql'

export namespace GetOrCreate {
  export interface Input {
    userId: number
  }
  export interface Output {
    getOrCreateLiveCheckinMonthCurrent: Response<LiveCheckinMonth>
  }
}

export namespace GetFirst {
  export interface Input {
    userId?: number
    yearCheckin?: number
    monthCheckin?: number
  }
  export interface Output {
    getLiveCheckinMonthFirst: Response<LiveCheckinMonth>
  }
}

class LiveCheckinMonthsService {
  async getOrCreateCurrent(params: GetOrCreate.Input) {
    const res = await graphClient.request<GetOrCreate.Output>(
      GET_OR_CREATE_LIVE_CHECKIN_MONTH_CURRENT,
      params,
    )
    return res?.getOrCreateLiveCheckinMonthCurrent
  }

  async getFirst(params: GetFirst.Input) {
    const res = await graphClient.request<GetFirst.Output>(
      GET_LIVE_CHECKIN_MONTH_FIRST,
      params,
    )
    return res?.getLiveCheckinMonthFirst
  }
}

export const liveCheckinMonthsService = new LiveCheckinMonthsService()
